import React from 'react'
import { Link } from '@superhi/design'

import { createModelPage } from '../../utils'
import { API } from '../../../../api'

import Create from './Create'
import Update from './Update'
import { INDEX, VIEW } from './queries'
import { DELETE } from './mutations'

export default createModelPage<
  API.product_books_index_productBooks_nodes,
  API.product_books_view_productBook
>({
  name: 'Product Books',
  index: {
    queryKey: 'productBooks',
    query: INDEX,
  },
  view: {
    queryKey: 'productBook',
    query: VIEW,
  },
  edit: Update,
  create: Create,
  destroy: {
    mutation: DELETE,
  },
})
